<tui-hosted-dropdown
    #fonts
    [content]="fontsDropdown"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        appearance="icon"
        icon="tuiIconFontLarge"
        tuiHintDirection="top-left"
        tuiHintDescribe
        [tuiHint]="fontText$ | async"
        [pseudoActive]="fonts.open"
        [focusable]="fonts.open"
    ></button>
    <ng-template #fontsDropdown>
        <tui-data-list>
            <button
                *ngFor="let item of fontsOptions$ | async"
                tuiOption
                [style.fontFamily]="item.family"
                [attr.automation-id]="'tui_font__' + (item.name || '' | lowercase)"
                [style.fontSize.px]="item.px"
                [style.fontWeight]="item.weight"
                [ngClass]="item?.ngClass || {}"
                [ngStyle]="item?.ngStyle || {}"
                (click)="setFontOption(item)"
            >
                {{ item.name }}
            </button>
        </tui-data-list>
    </ng-template>
</tui-hosted-dropdown>
